import {userActionTypes} from "../actions/actionTypes";
import {domesticPartnershipText, languages, spouseText, civilUnionText} from "../utils/common";

const initialState = {
    maritalStatus: null,
    dependents: null,
    typicallyPayInfo: null,
    highDeductibleInfo: null,
    leftoverMoney: null,
    lang: languages.ENGLISH,
    coverageOption: null,
    costPerOption: null,
    moderateCoverageSelected: null,
    severeCoverageSelected: null,
    catastrophicCoverageSelected: null,
    moderateCoverageRecommended: null,
    severeCoverageRecommended: null,
    catastrophicCoverageRecommended: null,
    costValue: null,
    costEnhanced: null,
    costPremier: null,
    selectedState: null,
    streetAddress: null,
    appartment: null,
    zipCode: null,
    city: null,
    birthdate: null,
    ssn: null,
    middleName: null,
    suffix: null,
    daytimePhoneNumber: null,
    phoneType: null,
    employerContribution: null,
    cost: null,
    dependentList: [],
    validEmployerPasscode: false,
    validSsnVerification: false,
    firstName: null,
    lastName: null,
    lastVisitedSavePoint: {
        route: null,
        step: null,
    },
    enrolleeSfId: null,
    account: {},
    gender: null,
    selectedTierBrellaSelect: {
        value: false,
        premier: false,
        enhanced: false,
    },
    fetchPlanRecommendation: true,
    resetTokenEmail: null,
    enrollmentReceivedDate: null,
    recommendationSkipped: null,
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case userActionTypes.SET_MARITAL_STATUS:
            return {
                ...state,
                maritalStatus: action.payload
            };
        case userActionTypes.SET_DEPENDENTS:
            return {
                ...state,
                dependents: action.payload
            };

        case userActionTypes.SET_HEALTH_PLAN_DETAILS:
            return {
                ...state,
                typicallyPayInfo: action.payload.typicallyPayInfo,
                highDeductibleInfo: action.payload.highDeductibleInfo,
            };
        case userActionTypes.SET_LEFTOVER_MONEY:
            return {
                ...state,
                leftoverMoney: action.payload
            };
        case userActionTypes.SET_LANGUAGE:
            return {
                ...state,
                lang: action.payload
            };
        case userActionTypes.SET_COVERAGE_OPTION:
            const {selectedCoverageOption, deleteChildren, deleteSpouse} = action.payload;
            let deps = state.dependentList;
            if(!!deps && deps.length > 0){
                deps = getDepsFromDeletes(deps, deleteChildren, deleteSpouse)
            }
            return {
                ...state,
                dependentList: [...deps],
                coverageOption: selectedCoverageOption,
            };
        case userActionTypes.SET_COST_PER_OPTION:
            return {
                ...state,
                costPerOption: action.payload
            };

        case userActionTypes.SET_MODERATE_COVERAGE:
            return {
                ...state,
                moderateCoverageSelected: action.payload
            };
        case userActionTypes.SET_SEVERE_COVERAGE:
            return {
                ...state,
                severeCoverageSelected: action.payload
            };
        case userActionTypes.SET_CATASTROPHIC_COVERAGE:
            return {
                ...state,
                catastrophicCoverageSelected: action.payload
            };
        case userActionTypes.SET_SELECTED_AND_RECOMMENDED_COVERAGE:
            return {
                ...state,
                moderateCoverageRecommended: action.payload.moderate,
                severeCoverageRecommended: action.payload.severe,
                catastrophicCoverageRecommended: action.payload.catastrophic,
                moderateCoverageSelected: action.payload.moderateSelected,
                severeCoverageSelected: action.payload.severeSelected,
                catastrophicCoverageSelected: action.payload.catastrophicSelected,
            };
        case userActionTypes.SET_SELECT_COST:
            return {
                ...state,
                costValue: action.payload.costValue,
                costEnhanced: action.payload.costEnhanced,
                costPremier: action.payload.costPremier,
                contribValue: action.payload.contribValue,
                contribEnhanced: action.payload.contribEnhanced,
                contribPremier: action.payload.contribPremier,
            };
        case userActionTypes.SET_SELECTED_STATE:
            return {
                ...state,
                selectedState: action.payload,
            };

        case userActionTypes.SET_STREET_ADDRESS:
            return {
                ...state,
                streetAddress: action.payload,
            };
        case userActionTypes.SET_APPARTMENT:
            return {
                ...state,
                appartment: action.payload,
            };
        case userActionTypes.SET_ZIP_CODE:
            return {
                ...state,
                zipCode: action.payload,
            };
        case userActionTypes.SET_CITY:
            return {
                ...state,
                city: action.payload,
            };
        case userActionTypes.SET_BIRTHDATE:
            return {
                ...state,
                birthdate: action.payload,
            };
        case userActionTypes.SET_SSN:
            return {
                ...state,
                ssn: action.payload,
            };
        case userActionTypes.SET_ENROLLMENT_RECEIVED_DATE:
            return {
                ...state,
                enrollmentReceivedDate: action.payload,
            };
        case userActionTypes.SET_FIRST_NAME:
            return {
                ...state,
                firstName: action.payload,
            };
        case userActionTypes.SET_LAST_NAME:
            return {
                ...state,
                lastName: action.payload,
            };
        case userActionTypes.SET_PLAN_CONTRIB_COST:
            return {
                ...state,
                employerContribution: action.payload.employerContribution,
                cost: action.payload.cost,
            };
        case userActionTypes.SET_DEPENDENT:
            const { dependent } = action.payload;
            const { dependentList, ...rest } = state;

            const updatedDependentList = dependentList ? [...dependentList] : [];
            const idx = updatedDependentList.findIndex(d => d.id === dependent.id);
            if (idx === -1) {
                updatedDependentList.push(dependent);
            } else {
                updatedDependentList[idx] = dependent;
            }

            return {
                ...rest,
                dependentList: updatedDependentList,
            };
        case userActionTypes.DELETE_DEPENDENT:{
            const { id } = action.payload;
            let {dependentList, ...rest} = state;
            const idx = dependentList.findIndex(d => d.id === id);
            dependentList.splice(idx, 1);
            return {
                ...rest,
                dependentList: [...dependentList]
            };
        }
        case userActionTypes.REMOVE_CHILD_IDX:{
            let {childrenDependents, ...rest} = state;
            if(!!childrenDependents && !!childrenDependents[action.payload]){
                childrenDependents[action.payload] = null;
            }
            return {
                ...rest,
                childrenDependents: [...childrenDependents]
            };
        }
        case userActionTypes.VALID_EMPLOYER_PASSCODE:{
            const {validEmployerPasscode, ...rest} = state;
            return {
                ...rest,
                validEmployerPasscode: true,
            }
        }
        case userActionTypes.VALID_SSN_VERIFICATION:{
            const {validSsnVerification, ...rest} = state;
            return {
                ...rest,
                validSsnVerification: true,
            }
        }
        case userActionTypes.SET_MIDDLE_NAME:
            return {
                ...state,
                middleName: action.payload,
            };
        case userActionTypes.SET_SUFFIX:
            return {
                ...state,
                suffix: action.payload,
            };
        case userActionTypes.SET_DAYTIME_PHONE:
            return {
                ...state,
                daytimePhoneNumber: action.payload,
            };
        case userActionTypes.SET_LAST_VISITED_SAVEPOINT_ROUTE:
            const {route, step} = action.payload;
            return {
                ...state,
                lastVisitedSavePoint: {
                    route,
                    step
                },
            };
        case userActionTypes.SET_PHONE_TYPE:
            return {
                ...state,
                phoneType: action.payload,
            };
        case userActionTypes.SET_ENROLLEESFID:
            return {
                ...state,
                enrolleeSfId: action.payload,
            };
        case userActionTypes.RESET_USER_DATA:
            const {lang} = state;
            return {
                ...initialState,
                dependentList: state.dependentList,
                lang,
            }
        case userActionTypes.OVERWRITE_STATE: {
            const {
                maritalStatus, dependents, typicallyPayInfo, highDeductibleInfo, leftoverMoney, lang,
                coverageOption, costPerOption, moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected,
                moderateCoverageRecommended, severeCoverageRecommended, catastrophicCoverageRecommended, costValue, costEnhanced,
                costPremier, selectedState, streetAddress, appartment, zipCode, city, birthdate, ssn, middleName, suffix,
                daytimePhoneNumber, phoneType, employerContribution, cost, validEmployerPasscode, recommendationSkipped,
                validSsnVerification, firstName, lastName, lastVisitedSavePoint, enrolleeSfId, selectedTierBrellaSelect, fetchPlanRecommendation, gender
            } = action.payload;
            const deletes = alterDependentInfoBasedOnCoverage(coverageOption);
            let deps = state.dependentList;
            if(!!deps && deps.length > 0){
                deps = getDepsFromDeletes(deps, deletes.deleteChildren, deletes.deleteSpouse)
            }
            return {
                ...state,
                maritalStatus,
                dependents,
                typicallyPayInfo,
                highDeductibleInfo,
                leftoverMoney,
                lang,
                coverageOption,
                costPerOption,
                moderateCoverageSelected,
                severeCoverageSelected,
                catastrophicCoverageSelected,
                moderateCoverageRecommended,
                severeCoverageRecommended,
                catastrophicCoverageRecommended,
                costValue,
                costEnhanced,
                costPremier,
                selectedState,
                streetAddress,
                appartment,
                zipCode,
                city,
                birthdate,
                ssn,
                middleName,
                suffix,
                daytimePhoneNumber,
                phoneType,
                employerContribution,
                cost,
                validEmployerPasscode,
                validSsnVerification,
                firstName,
                lastName,
                lastVisitedSavePoint,
                enrolleeSfId,
                selectedTierBrellaSelect,
                fetchPlanRecommendation,
                gender,
                recommendationSkipped,
                dependentList: [...deps],
            }
        }
        case userActionTypes.SET_ACCOUNT:
            return {
                ...state,
                account: action.payload,
            }
        case userActionTypes.SET_ALL_ADDRESS_FIELDS: {
            const data = action.payload;
            return {
                ...state,
                selectedState: data.state,
                streetAddress: data.streetAddress,
                appartment: data.appartment,
                zipCode: data.zipCode,
                city: data.city,
            }
        }
        case userActionTypes.SET_GENDER: {
            return {
                ...state,
                gender: action.payload,
            }
        }
        case userActionTypes.SET_BRELLA_SELECT_TIER_SELECTED: {
            const {value, premier, enhanced} = action.payload;
            return {
                ...state,
                selectedTierBrellaSelect: {value, premier, enhanced},
            }
        }
        case userActionTypes.SET_FETCH_PLAN_RECOMMENDATION: {
            const {fetchPlanRecommendation} = action.payload;
            return {
                ...state,
                fetchPlanRecommendation,
            }
        }
        case userActionTypes.SET_RESET_TOKEN_EMAIL: {
            const {resetTokenEmail} = action.payload;
            return {
                ...state,
                resetTokenEmail,
            }
        }
        case userActionTypes.SET_SKIP_RECOMMENDATION: {
            const {recommendationSkipped} = action.payload;
            return {
                ...state,
                recommendationSkipped,
            }
        }
        case userActionTypes.SET_DEPENDENT_LIST: {
            return {
                ...state,
                dependentList: action.payload
            }
        }
        default:
            return state
    }
};

const getDepsFromDeletes = (depList, deleteChildren, deleteSpouse) => {
    return depList.map(dep => {
        return {
            ...dep,
            removedFromPlan: deleteChildren ? dep.relationship === "Child"
            : deleteSpouse ? (dep.relationship === spouseText || dep.relationship === domesticPartnershipText || dep.relationship === civilUnionText) : false
        }
    })
}

const alterDependentInfoBasedOnCoverage = (coverageOption) => {
    let deleteChildren;
    let deleteSpouse;
    switch(coverageOption){
        case 'employee':
            deleteChildren = true;
            deleteSpouse = true;
            break;
        case 'spouse':
            deleteChildren = true;
            deleteSpouse = false;
            break;
        case 'child':
            deleteChildren = false;
            deleteSpouse = true;
            break;
        default:
            deleteChildren = false;
            deleteSpouse = false;
    }
    return {deleteChildren, deleteSpouse};
}
